import { meetingRoomsConstants } from '../redux-constants'

const initialState = {
    list: [],
    error: null,
    //loading: false,
}

export default function meetingRooms(state = initialState, action) {
    let coworkingIndex, meetingRoomIndex
    switch (action.type) {
        case meetingRoomsConstants.AJAX_CALL_FAILURE:
            state.error = action.payload
            return state

        case meetingRoomsConstants.FETCH:
            //state.loading = false
            return state

        case meetingRoomsConstants.ADD_ITEMS:
            let coworkingStateIndex = state.list.findIndex(item => {
                return item.cowoRef === action.payload.cowoRef
            })

            if (coworkingStateIndex !== -1) {
                action.payload.list.forEach(cowo => {
                    if (
                        state.list[coworkingStateIndex].list
                            .map(e => e.id)
                            .indexOf(cowo.id) === -1
                    ) {
                        state.list[coworkingStateIndex].list.push(cowo)
                    }
                })
            } else {
                state.list = state.list.concat({
                    cowoRef: action.payload.cowoRef,
                    list: action.payload.list,
                })
            }
            state.error = null
            //state.loading = false
            return state

        case meetingRoomsConstants.UPDATE:
            coworkingIndex = state.list.findIndex(
                cowo => cowo.cowoRef === action.payload.cowoRef
            )

            meetingRoomIndex = state.list[coworkingIndex].list.findIndex(
                x => x.id === action.payload.id
            )

            if (meetingRoomIndex === -1) {
                state.error = `Error - Meeting Room with id ${action.payload.id} not found`
            } else if (coworkingIndex === -1) {
                state.list = state.list.concat(action.payload)
                state.error = null
            } else {
                state.list[coworkingIndex].list[meetingRoomIndex] =
                    action.payload.data
                state.error = null
            }
            //state.loading = false
            return state

        case meetingRoomsConstants.REMOVE:
            coworkingIndex = state.list.findIndex(
                cowo => cowo.cowoRef === action.payload.cowoRef
            )

            meetingRoomIndex = state.list[coworkingIndex].list.findIndex(
                x => x.id === action.payload.id
            )

            let coworkingMeetingRooms = state.list[coworkingIndex]

            if (meetingRoomIndex === -1) {
                state.error = `Error - Meeting Room with id ${action.payload.id} not found`
            } else if (coworkingIndex === -1) {
                state.list = state.list.concat(action.payload)
                state.error = null
            } else {
                coworkingMeetingRooms.list.splice(meetingRoomIndex, 1)
                state.list[coworkingIndex] = coworkingMeetingRooms
                state.error = null
            }

            //state.loading = false
            return state

        default:
            return state
    }
}
